import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbToast as ClbToast_ } from '@celebration/design-system/dist/lib/toast';
export const ClbToast = createComponent({
    tagName: ClbToast_.tagName,
    elementClass: ClbToast_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map